var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex inter-font",attrs:{"id":"wrapper"}},[_c('sidebar'),_vm._v(" "),_c('div',{attrs:{"id":"page-content-wrapper"}},[_c('navbar',{attrs:{"custom-breadcrumb":_vm.customBreadcrumb}}),_vm._v(" "),_c('div',{staticClass:"container-fluid mt-4"},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e9e60fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/Wrapper.vue
// module id = null
// module chunks = 